// extracted by mini-css-extract-plugin
export default {"heading":"NotFound_heading__IHOqN"};